/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pie } from '@ant-design/plots';
import IconEmpty from '../../assets/Images/icons/empty';
import { Spin } from 'antd';

export default function Dashboard2({ dataRisk, isLoading }) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const [riskInfo, setRiskInfo] = useState([]);

    useEffect(() => {
        if (dataRisk) {
            setRiskInfo(
                [
                    {
                        type: t('DashBoardRM.CompletedTheAssessment'),
                        value: dataRisk.successfullyRiskAssessment,
                        total: dataRisk.totalRiskAssessment,
                    },
                    {
                        type: t('DashBoardRM.InprogressRegistration'),
                        value: dataRisk.inprogressRiskAssessment,
                        total: dataRisk.totalRiskAssessment,
                    },
                    {
                        type: t('DashBoardRM.DidNotDoTheAssessment'),
                        value: dataRisk.todoRiskAssessment,
                        total: dataRisk.totalRiskAssessment,
                    },
                ].reverse()
            );
        }
    }, [dataRisk, lang]);

    const config = useMemo(() => {
        return {
            data: riskInfo,
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => {
                switch (type) {
                    case t('DashBoardRM.CompletedTheAssessment'):
                        return '#2CD9C5';
                    case t('DashBoardRM.InprogressRegistration'):
                        return '#8BEDE2';
                    default:
                        return '#C2FCF8';
                }
            },
            radius: 1,
            width: 280,
            height: 280,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: {
                title: true,
                content: {
                    content: t('DashBoardRM.RiskAssessment'),
                    style: {
                        fontSize: 14,
                        color: '#505D6F',
                    },
                },
            },
        };
    }, [riskInfo]);

    return (
        <Spin spinning={isLoading}>
            <div className="font-semibold text-xl">
                {t('DashBoardRM.ActivityRiskAssessmentResults')}
            </div>
            {dataRisk?.totalRiskAssessment ? (
                <div className="grid grid-cols-5 flex items-center">
                    <div
                        className="col-span-3 mt-4"
                        style={{ minHeight: '280px', maxHeight: '280px' }}
                    >
                        <Pie {...config} />
                    </div>
                    <div className="col-span-2">
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#2CD9C5"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('DashBoardRM.CompletedTheAssessment')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.successfullyRiskAssessment} (
                                {(
                                    (dataRisk.successfullyRiskAssessment /
                                        dataRisk.totalRiskAssessment) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#8BEDE2"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('DashBoardRM.InprogressRegistration')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.inprogressRiskAssessment} (
                                {(
                                    (dataRisk.inprogressRiskAssessment /
                                        dataRisk.totalRiskAssessment) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div
                            className="grid grid-cols-3 pt-2 pb-6"
                            style={{ borderBottom: '0.5px solid #E9EBF1' }}
                        >
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#C2FCF8"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('DashBoardRM.DidNotDoTheAssessment')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.todoRiskAssessment} (
                                {(
                                    (dataRisk.todoRiskAssessment /
                                        dataRisk.totalRiskAssessment) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>

                        <div className="grid grid-cols-3 pt-6">
                            <div className="col-span-2">
                                <div className="font-bold">{t('Total')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.totalRiskAssessment} (100%)
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
        </Spin>
    );
}
